import React, { useEffect, useState } from 'react';
import { Paper } from '@mui/material';
import { ChatContent } from '../../components/chatContent/ChatContent';
import { ChatList } from '../../components/chatList/ChatList';
import { Header } from '../../components/header/Header';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import { getProfile } from '../../store/actions/actions';
import { organizerSlice } from '../../store/slice/slice';
import { useStyles } from './noticePage.styles';

export const NoticePage = (): JSX.Element => {
  const conversationId = useAppSelector((state) => state.organizerReducer.conversationId);
  const noticePages = useAppSelector((state) => state.organizerReducer?.noticePages);
  const profile = useAppSelector((state) => state.organizerReducer.profile);
  const [chatList, setChatList] = useState(noticePages);
  const [message, setMessage] = useState('');
  const dispatch = useAppDispatch();
  const classes = useStyles();
  const paramsId = new URLSearchParams(window.location.search).get('id');

  const handleClick = (id: string) => {
    const value = localStorage.getItem(`chatDrafts${conversationId}`);
    if (message && value !== message) {
      const filterNoticePages = chatList.filter((item: any) => item.id !== (typeof conversationId === 'string' ? parseInt(conversationId) : conversationId));
      const getNoticeWithId = chatList.filter((item: any) => item.id === (typeof conversationId === 'string' ? parseInt(conversationId) : conversationId));
      filterNoticePages.unshift(...getNoticeWithId);
      setChatList(filterNoticePages);
      localStorage.setItem(`chatDrafts${conversationId}`, message);
      setMessage('');
    }
    dispatch(organizerSlice.actions.setConversationId(id));
  };

  useEffect(() => {
    if (profile) {
      const filterNoticePages = noticePages.filter((item: any) => profile.name === item.organization.name);
      setChatList(filterNoticePages);
    }
  }, [profile, noticePages]);

  useEffect(() => {
    getProfile()(dispatch);
    dispatch(organizerSlice.actions.setConversationId(paramsId));
  }, [dispatch]);

  return (
    <div>
      <Header />
      <div className={classes.mainContent}>
        <div className={classes.contentHeaderText}>Notice pages</div>
        <Paper className={classes.mainPaper}>
          <ChatList
            noticePages={chatList}
            handleClick={handleClick}
          />
          <ChatContent
            message={message}
            setMessage={setMessage}
          />
        </Paper>
      </div>
    </div>
  );
};
